import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  Col,
  Button,
  Form,
  Row,
  Container,
  Card,
  CardTitle,
  CardBody,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
import axios from "axios";
import CooperativeService from "../../../services/CooperativeService";
import COOPValidation from "./COOPValidation";
import toast from "react-hot-toast";

const COOPDetail = ({ setActiveTab, profileImage }) => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const coopId = user?.user?.cooperative_id;
  const token = user?.accessToken;
  const [coopEdit, setCoopEdit] = useState({
    nameEng: "",
    nameNep: "",
    phoneNumberEng: "",
    phoneNumberNep: "",
    email: "",
    addressEng: "",
    addressNep: "",
    messageEng: "",
    messageNep: "",
    userName: "",
    password: "",
    loginEmail: "",
    fullName: "",
  });

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const formik = useFormik({
    initialValues: {
      cooperative_id: coopId || "",
      NameEng: coopEdit.nameEng || "",
      NameNep: coopEdit.nameNep || "",
      PhoneNumberEng: coopEdit.phoneNumberEng || "",
      PhoneNumberNep: coopEdit.phoneNumberNep || "",
      AddressEng: coopEdit.addressEng || "",
      AddressNep: coopEdit.addressNep || "",
      MessageEng: coopEdit.messageEng || "",
      MessageNep: coopEdit.messageNep || "",
      Image: "",
      Username: coopEdit.userName || "",
      Email: coopEdit.email || "",
      Password: coopEdit.password || "",
      LoginEmail: coopEdit.loginEmail || "",
      FullName: coopEdit.fullName || "",
    },
    COOPValidation,
    enableReinitialize: true,
    onSubmit: async (values, { setErrors }) => {
      console.log("🚀 ~ onSubmit: ~ values:", values);
      try {
        const formData = new FormData();
        formData.append("cooperative_id", values.cooperative_id);
        formData.append("NameEng", values.NameEng);
        formData.append("NameNep", values.NameNep);
        formData.append("PhoneNumberEng", values.PhoneNumberEng);
        formData.append("PhoneNumberNep", values.PhoneNumberNep);
        formData.append("AddressEng", values.AddressEng);
        formData.append("AddressNep", values.AddressNep);
        formData.append("MessageEng", values.MessageEng);
        formData.append("MessageNep", values.MessageNep);
        formData.append("Username", values.Username);
        formData.append("Email", values.Email);
        formData.append("LoginEmail", values.LoginEmail);
        formData.append("Password", values.Password);
        formData.append("FullName", values.FullName);

        if (profileImage) {
          formData.append("Image", profileImage);
        }

        const response = await axios.put(
          `http://api.dsccou.sebs.asia/api/cooperatives/${coopId}`,
          formData,
          {
            headers: {
              "Content-type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("put response", response);
        toast.success("Saved successfully.");
        localStorage.setItem("coopDetail", JSON.stringify(values));
        setActiveTab("2");
      } catch (error) {
        console.log("Error submitting form", error.response?.data || error);
        toast.error("Error submitting form. Please try again.");
      }
    },
  });

  const handleCancel = () => {
    navigate("/");
  };

  const handleNext = () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await CooperativeService.getById(coopId);
        console.log("responseee", response);
        setCoopEdit(response);
      } catch (error) {
        console.log("🚀 ~ async ~ error:", error);
      }
    })();
  }, [coopId]);

  return (
    <Container>
      <Form onSubmit={formik.handleSubmit}>
        <Card>
          <CardTitle className="p-2">Login Details</CardTitle>
          <CardBody>
            <Row>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"User Name"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"Username"}
                  name={"Username"}
                  placeholder={"Username"}
                  value={formik.values.Username}
                  error={formik.errors.Username}
                  touched={formik.touched.Username}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Full Name"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"FullName"}
                  name={"FullName"}
                  placeholder={"FullName"}
                  value={formik.values.FullName}
                  error={formik.errors.FullName}
                  touched={formik.touched.FullName}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Login Email"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"LoginEmail"}
                  name={"LoginEmail"}
                  type={"email"}
                  placeholder={"LoginEmail Address"}
                  value={formik.values.LoginEmail}
                  error={formik.errors.LoginEmail}
                  touched={formik.touched.LoginEmail}
                />
              </Col>
              <Col lg={6} className="position-relative">
                <CustomInput
                  
                  label={"Password"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"Password"}
                  name={"Password"}
                  type={passwordVisible ? "text" : "password"}
                  placeholder={"Password"}
                  value={formik.values.Password}
                  error={formik.errors.Password}
                  touched={formik.touched.Password}
                  className={formik.values.Password === "" ? "password-asterisk" : ""}

                />
                <button
                  className="btn btn-link position-absolute m-1 end-0 top-50 translate-middle-y text-decoration-none text-muted"
                  type="button"
                  id="password-addon"
                  onClick={togglePasswordVisibility}
                >
                  <i className={passwordVisible ? "ri-eye-off-fill" : "ri-eye-fill"}></i>
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardTitle className="p-2">COOP Details</CardTitle>
          <CardBody>
            <Row>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Co-operative Name"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"NameEng"}
                  name={"NameEng"}
                  placeholder={"Co-operative name"}
                  value={formik.values.NameEng}
                  error={formik.errors.NameEng}
                  touched={formik.touched.NameEng}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"सहकारी नाम"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"NameNep"}
                  name={"NameNep"}
                  placeholder={"सहकारी नाम"}
                  value={formik.values.NameNep}
                  error={formik.errors.NameNep}
                  touched={formik.touched.NameNep}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Phone Number"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"PhoneNumberEng"}
                  name={"PhoneNumberEng"}
                  placeholder={"Phone Number"}
                  value={formik.values.PhoneNumberEng}
                  error={formik.errors.PhoneNumberEng}
                  touched={formik.touched.PhoneNumberEng}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"फोन नम्बर"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"PhoneNumberNep"}
                  name={"PhoneNumberNep"}
                  placeholder={"फोन नम्बर"}
                  value={formik.values.PhoneNumberNep}
                  error={formik.errors.PhoneNumberNep}
                  touched={formik.touched.PhoneNumberNep}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Address"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"AddressEng"}
                  name={"AddressEng"}
                  placeholder={"Address"}
                  value={formik.values.AddressEng}
                  error={formik.errors.AddressEng}
                  touched={formik.touched.AddressEng}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"ठेगाना"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"AddressNep"}
                  name={"AddressNep"}
                  placeholder={"ठेगाना"}
                  value={formik.values.AddressNep}
                  error={formik.errors.AddressNep}
                  touched={formik.touched.AddressNep}
                />
              </Col>
        
              <Col lg={12}>
                <CustomInput
                  required
                  label={"Email Address"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"Email"}
                  name={"Email"}
                  type={"email"}
                  placeholder={"Email Address"}
                  value={formik.values.Email}
                  error={formik.errors.Email}
                  touched={formik.touched.Email}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Message"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"MessageEng"}
                  name={"MessageEng"}
                  type={"textarea"}
                  placeholder={"Message"}
                  value={formik.values.MessageEng}
                  error={formik.errors.MessageEng}
                  touched={formik.touched.MessageEng}
                />
              </Col>
              <Col lg={6}>
                <CustomInput
                  required
                  label={"Message"}
                  handleBlur={formik.handleBlur}
                  handleChange={formik.handleChange}
                  id={"MessageNep"}
                  name={"MessageNep"}
                  type={"textarea"}
                  placeholder={"Message"}
                  value={formik.values.MessageNep}
                  error={formik.errors.MessageNep}
                  touched={formik.touched.MessageNep}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Col lg={12}>
          <div className="d-flex align-items-center gap-1 justify-content-end">
            <Button
              style={{ width: "120px", marginTop: "10px" }}
              type="button"
              className="btn btn-danger"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              style={{ width: "120px", marginTop: "10px" }}
              type="button"
              className="btn btn-success"
              onClick={handleNext}
            >
              Save
            </Button>
          </div>
        </Col>
      </Form>
    </Container>
  );
};

export default COOPDetail;
